import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';
import { useIsMobile } from '@/common/hooks/useIsMobile';
import HandClockDraw from '@/common/svg/hand-clock-draw.svg';
import ManagerOnlineDraw from '@/common/svg/manager-online-draw.svg';
import PhoneIcon from '@/common/svg/phone-icon.svg';
import { FeatureCard } from '@/components/FeatureCard';

export const CustomerService = () => {
  const isMobile = useIsMobile();
  return (
    <section className={cn('section', styles.section)}>
      <div className="container">
        <h2 className={styles.title}>
          <FormattedMessage defaultMessage="Служба заботы о клиентах" />
        </h2>
        <div className={styles.contentWrapper}>
          <FeatureCard Icon={ManagerOnlineDraw}>
            <div className={styles.cardTextWrapper}>
              <p>
                <FormattedMessage
                  defaultMessage="Мы с радостью дадим любое разъяснение на все ваши вопросы по
                следующим телефонам"
                />
                :
              </p>
              <div className={styles.cardSubText}>
                <PhoneIcon />
                <a href="tel:+77719444100">+7 771 944 41 00</a>
              </div>
            </div>
          </FeatureCard>
          <FeatureCard Icon={HandClockDraw}>
            <div className={styles.serviceTimeTextWrapper}>
              <p>
                <FormattedMessage defaultMessage="Прием заявок круглосуточно и без выходных" />
              </p>
              <p>
                <FormattedMessage defaultMessage="Рассмотрение и отправка денег" />
                {isMobile ? <br /> : ' '}
                <span>
                  <FormattedMessage defaultMessage="Пн-Пт" /> | 09:00-18:00
                </span>
              </p>
              <p>
                <FormattedMessage defaultMessage="Время обработки звонков" />
                {isMobile ? <br /> : ' '}
                <span>
                  <FormattedMessage defaultMessage="Пн-Пт" /> | 09:00-18:00
                </span>
              </p>
            </div>
          </FeatureCard>
        </div>
      </div>
    </section>
  );
};
